import { render, staticRenderFns } from "./CreateOidcGroupModal.vue?vue&type=template&id=1165eb92&"
import script from "./CreateOidcGroupModal.vue?vue&type=script&lang=js&"
export * from "./CreateOidcGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports